export default __webpack_public_path__ + "static/media/stephen-larger.0ff50c5d.jpeg";